import React, { useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import 'react-dropdown/style.css';
import logo from '../assets/images/logo.png';
import '../styles/Navbar.css';

const Navbar = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const navbarRef = useRef(null);

    const location = useLocation();
    const navigate = useNavigate();

    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const closeMenu = () => {
        setIsMenuOpen(false);
    };

    const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen);
    };

    const handleScrollToSection = (sectionId) => {
        closeMenu();
        setIsDropdownOpen(false);
        const section = document.getElementById(sectionId);

        if (location.pathname === '/') {
            if (section) {
                section.scrollIntoView({ behavior: 'smooth' });
            }
        } else {
            navigate(`/`);
        }
    };

    useEffect(() => {
        const handleScroll = () => {
            const navbar = navbarRef.current;
            if (window.scrollY > 50) {
                navbar.classList.add('scrolled');
            } else {
                navbar.classList.remove('scrolled');
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const handleEditionSelect = (selectedOption) => {
        closeMenu();
        setIsDropdownOpen(false);
        navigate(`/${selectedOption}`);
    };

    return (
        <nav ref={navbarRef} className="navbar">
            <div className="navbar-brand">
                <img src={logo} alt="Logo del Evento" className="navbar-logo" />
            </div>

            {/* Icono del menú (sólo visible en móvil) */}
            <i
                className={`menu-icon ${isMenuOpen ? 'fas fa-times' : 'fas fa-bars'}`}
                onClick={toggleMenu}
            ></i>

            {/* Botones principales */}
            <ul className={`navbar-links ${isMenuOpen ? 'active' : ''}`}>
                <li>
                    <button className="nav-button" onClick={() => handleScrollToSection('inicio-section')}>
                        INICIO
                    </button>
                </li>
                <li className="dropdown-container">
                    <button className="dropdown-button" onClick={toggleDropdown}>
                        EDICIONES
                        <span className="dropdown-arrow"> &#9660;</span>
                    </button>
                    <ul className={`dropdown-menu ${isDropdownOpen ? 'active' : ''}`}>
                        <li onClick={() => handleEditionSelect('edicion1')}>
                            1ª Edición
                        </li>
                        {/* Add more options as needed */}
                    </ul>
                </li>
                <li>
                    <button className="nav-button" onClick={() => handleScrollToSection('contacto-section')}>
                        CONTACTO
                    </button>
                </li>
            </ul>
        </nav>
    );
};

export default Navbar;